import React, { useContext } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import FormWrap from "integrations/aws/common/FormWrap";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import { renderOptions } from "integrations/aws/common/Options";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import { KINESIS_LOG_TYPES } from "integrations/aws/common/constants";
import FormDataContext from "integrations/contexts/FormDataContext";
const StyledFormWrap = styled(FormWrap)`
  padding-top: 25px;
`;
const SkipHealthCheck = ({ onChange, onSubmit }) => {
  const { t } = useTranslation("integrations");
  const { formData } = useContext(FormDataContext);
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: t("aws_skip_health_check.title") }, /* @__PURE__ */ React.createElement(
    StyledFormWrap,
    {
      onSubmit,
      buttonContent: t("aws_skip_health_check.confirm_button"),
      title: t("aws_skip_health_check.form_title"),
      disabled: !(formData.awsCloudWatchKinesisInputType && formData.awsCloudWatchKinesisInputType.value),
      description: /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
        Trans,
        {
          t,
          i18nKey: "aws_skip_health_check.description",
          values: { streamName: formData.awsCloudWatchKinesisStream.value },
          components: { strong: /* @__PURE__ */ React.createElement("strong", null) }
        }
      ))
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsCloudWatchKinesisInputType",
        type: "select",
        fieldData: formData.awsCloudWatchKinesisInputType,
        onChange,
        label: t("aws_skip_health_check.input_type_label"),
        required: true
      },
      renderOptions(KINESIS_LOG_TYPES, t("aws_skip_health_check.choose_log_type"))
    )
  ));
};
export default SkipHealthCheck;
